import axios from 'axios';

const state = {
  summary: '',
  loading: false,
  error: null,
};

const mutations = {
  // eslint-disable-next-line no-shadow
  SET_LOADING(state, loading) {
    state.loading = loading;
  },
  // eslint-disable-next-line no-shadow
  SET_SUMMARY(state, summary) {
    state.summary = summary;
  },
  // eslint-disable-next-line no-shadow
  CLEAR_SUMMARY(state) {
    state.summary = '';
    state.loading = false;
    state.error = null;
  },
  // eslint-disable-next-line no-shadow
  SET_ERROR(state, error) {
    state.error = error;
  },
};

const actions = {
  async generateSummary({ commit }, { chartData, values }) {
    // AC-01: Loading skeleton appears within 100ms
    commit('SET_LOADING', true);
    commit('SET_ERROR', null);
    commit('SET_SUMMARY', '');

    try {
      // AC-05: 3-second timeout
      const response = await axios.post('/api/ai-summary/', {
        chartData,
        values,
      }, { timeout: 60000 });

      if (response.data && response.data.summary) {
        // AC-02: Summary replaces skeleton
        commit('SET_SUMMARY', response.data.summary);
      } else {
        throw new Error('Invalid response from AI API');
      }
    } catch (error) {
      // AC-05, AC-06: Silent failure
      commit('SET_ERROR', error.message);
      commit('SET_SUMMARY', '');
    } finally {
      commit('SET_LOADING', false);
    }
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
